

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import { i18n, setI18nLanguage } from '@/i18n'
import actualidadModule from '@/store/actualidad'
import formulariosModule from '@/store/formularios'
import VeeValidate, { Validator } from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';
import messages from '@/translations';


export const store = new Vuex.Store({
  state: {
    language: null,
    server: 'https://back.risi.es',
    // server : 'http://dmb.risi.es/'
    likes: JSON.parse(localStorage.getItem('likes')) || new Array(),
    hints: JSON.parse(localStorage.getItem('hints')) || new Array(),
    validators: {
      es: validatorEs,
      en: validatorEn,
    }
  },
  actions: {
    changeLanguage: ({ commit, state }, changeTo) => {
      return new Promise((resolve, reject) => {
        commit('setLanguage', changeTo);
        setI18nLanguage(changeTo);
        Validator.localize('es', state.validators[changeTo] ? state.validators[changeTo] : state.validators['en']); 
        document.documentElement.setAttribute("lang", changeTo);
        resolve(changeTo);
      });
    }
  },
  getters: {
    getLanguage: state => state.language,
    getServer: state => state.server,
    getTexts: state => {
      return messages[state.language];
    }
  },
  mutations: {
    setLanguage(state, lang) {
      state.language = lang;
    },
  },
  modules: {
    actualidadModule,
    formulariosModule
  }

});

export default store;


// WEBPACK FOOTER //
// ./src/store/store.js